import React from 'react';
import _ from 'underscore';

import UsageView from './components/accountUsage'
import ApiKeyManager from './components/ApiKeyManager';
import RestrictedComponent from '../lib/components/form/RestrictedComponent';

import schema from '../routes/permissions/schema';

class AccountManager extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            tab: 'AccountUsage',
            createUserModal: false,
            isPasswordResetResolving: false
        }

        this.toggleTab = this.toggleTab.bind(this)
    
        this.renderTab = this.renderTab.bind(this)
    }

    toggleTab(tab, event) {
        event && event.preventDefault();
        this.setState({ tab: tab });
    }


    render() {
        var self = this;
        
        function renderClassName(tab) {
            var active = self.state.tab == tab ? 'active' : '';
            return active;
        }
        return (
          <div id='account-manager'>

            <ul className='nav nav-tabs' role='tablist'>
              <li
                key='AccountUsage'
                role='presentation'
                className={renderClassName('AccountUsage')}
              >
                <RestrictedComponent
                  permissionCheck={schema.ACCOUNT.READ_BILLING}
                  style={{ padding: '10px 15px', lineHeight: 3 }}
                >
                  <a href='#' onClick={this.toggleTab.bind(null, 'AccountUsage')}>
                  Account Usage
                  </a>
                </RestrictedComponent>
              </li>

              <RestrictedComponent permissionCheck={schema.ACCOUNT.READ_API}>
                <li
                  key='api'
                  role='presentation'
                  className={renderClassName('api')}
                >
                  <a href='#' onClick={this.toggleTab.bind(null, 'api')}>
                    Api
                  </a>
                </li>
              </RestrictedComponent>
            </ul>

            <div className='tab-content'>{this.renderTab()}</div>
          </div>
        )
    }

    renderTab() {
        switch (this.state.tab) {
            case 'users':
                return <UsersListView
                    onEditAccount={this.handleEditUser}
                    handleDelete={this.handleDelete}
                    getUsers={this.props.getUsers}
                    thisUser={this.props.user.data}
                />
            case 'api':
                return <ApiKeyManager
                    keys={this.props.keys}
                    currentUser={this.props.user.data}
                    actions={this.props.actions}
                    clientID={this.props.clientID}
                />;

            case 'AccountUsage':
                return <UsageView {...this.props} />;
        }
    }
}

export default AccountManager
